import { z } from "zod";

import { requiredFile, requiredString } from "@/common/components/forms/schema";

const IMPORT_TYPES = {
  EAGRI: "eagri",
  MANUAL: "manual",
  SHAPEFILE: "shapefile",
} as const;

const CZECH_COUNTRY_CODE = "CZ";

type ImportType = (typeof IMPORT_TYPES)[keyof typeof IMPORT_TYPES];

const manualFarmSchema = z.object({
  farmName: requiredString(),
});

const shapefileFarmSchema = z.object({
  farmName: requiredString(),
  shapeFile: requiredFile("FarmImport.errors.incorrectShpFile"),
});

type ManualFarmFormValues = z.infer<typeof manualFarmSchema>;
type ShapefileFarmFormValues = z.infer<typeof shapefileFarmSchema>;

const MANUAL_FARM_INITIAL_VALUES: ManualFarmFormValues = {
  farmName: "",
};

const SHAPEFILE_FARM_INITIAL_VALUES: ShapefileFarmFormValues = {
  farmName: "",
  shapeFile: null,
};

export {
  manualFarmSchema,
  shapefileFarmSchema,
  MANUAL_FARM_INITIAL_VALUES,
  SHAPEFILE_FARM_INITIAL_VALUES,
  IMPORT_TYPES,
  CZECH_COUNTRY_CODE,
  type ImportType,
  type ManualFarmFormValues,
  type ShapefileFarmFormValues,
};
